import LoaderIcon from './loader.svg'
import styles from './Loader.module.scss'

export const Loader = () => {
    return (
        <div className={styles.loader}>
            <span className={styles.icon}>
                <LoaderIcon />
            </span>
        </div>
    )
}
